import {TransactionControllerApi, ValidationRequest} from 'src/api/api';
import {BaseApi, configuration} from 'src/api/BaseApi';

export enum TransactionType {
    BidRequest = 'BidRequest',
    BidResponse = 'BidResponse',
    Win = 'Win',
    Impression = 'Impression'
}

class ValidationApi extends BaseApi {
    api: TransactionControllerApi;

    constructor() {
        super();
        this.api = new TransactionControllerApi(configuration, configuration.basePath, this.customFetch);
    }

    getTransaction(validationRequest: ValidationRequest): Promise<{ [key: string]: string; }> {
        return this.api.transaction(validationRequest)
    }

    matchTransaction(validationRequest: ValidationRequest) {
        return this.api.matchHash(validationRequest)
    }

}

const validationApi = new ValidationApi()

export default validationApi
